module.exports = __webpack_public_path__ + "img/banner3.b80ea401.jpg";